//! @ngInject
export function workersSettingsCtrl($scope, $rootScope, DatabaseApi, toaster, Consts) {
    $scope.credentials = {
        username: '',
        password: ''
    };
    $scope.showPassword = false;
    $scope.isLoading = false;

    // Load existing credentials if any
    function loadCredentials() {
        $scope.isLoading = true;
        DatabaseApi.get('agencies/' + $rootScope.agencyId + '/agency_members/' + $rootScope.agencyMemberId + '/worker_credentials').then(function (res) {
            if (res.data) {
                $scope.credentials = res.data;
            }
        })
        .catch(function(err) {
            console.error('Failed to load credentials:', err);
            toaster.pop('error', 'Error', 'Failed to load credentials');
        })
        .finally(function() {
            $scope.isLoading = false;
        });
    }

    // Save credentials
    $scope.saveCredentials = function() {
        if (!$scope.credentials.username || !$scope.credentials.password) {
            toaster.pop('error', 'Error', 'Please fill in both username and password');
            return;
        }

        $scope.isLoading = true;
        const body = {
            username: $scope.credentials.username,
            password: $scope.credentials.password,
            workerType: "StateHealthCommerceSystem"
        }
        
        DatabaseApi.put('agencies/' + $rootScope.agencyId + '/agency_members/' + $rootScope.agencyMemberId + '/worker_credentials', body).then(function (res) {
            toaster.pop('success', 'Success', 'Credentials saved successfully');
            loadCredentials();
        }, function (err) {
            toaster.pop('error', 'Error', 'Failed to save credentials');
            console.error('Failed to save credentials:', err);
        })
        .finally(function() {
            $scope.isLoading = false;
        });
    };

    // Load credentials when controller initializes
    loadCredentials();
} 